import React, {useEffect, useState} from 'react';

import {HStack, Icon, Text, VStack, Spinner} from '@chakra-ui/react';
import {MailWarning} from 'lucide-react';

import {Button} from '@/components';
import {useApi} from '@/uses/useApi';
import {useLanguage} from '@/contexts/languageContext';

/**
 * Confirmation avant l'envoi en masse du mail de relance de renouvellement
 * d'adhésion. Affiche le nombre exact de destinataires (anciens adhérents
 * dont le compte est actuellement désactivé) avant de lancer le job.
 */
export const RenewalMailConfirmation = ({close, successCallback, errorCallback}) => {
    const api = useApi();
    const {t} = useLanguage();

    const [count, setCount] = useState(null);
    const [isSending, setIsSending] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        api.ApiService.rawGet('/user/renewal-mail/count')
            .then((res) => {
                if (res?.data?.type === 'success') {
                    setCount(res.data.value?.count ?? 0);
                } else {
                    setHasError(true);
                }
            })
            .catch(() => setHasError(true));
    }, [api.ApiService]);

    const send = () => {
        setIsSending(true);
        api.ApiService.rawPost('/user/renewal-mail', {})
            .then((res) => {
                if (res?.data?.type === 'success') {
                    successCallback?.(count);
                    close();
                } else {
                    errorCallback?.();
                    setIsSending(false);
                }
            })
            .catch(() => {
                errorCallback?.();
                setIsSending(false);
            });
    };

    return <VStack p="5" w="100%" gap="1rem">
        <VStack align="center">
            <Icon as={MailWarning} boxSize={10} color="secondary.500" mx="auto"/>
            <Text fontSize="2xl">{t('renewal.title')}</Text>
        </VStack>

        {hasError
            ? <Text textAlign="center">{t('renewal.countError')}</Text>
            : count === null
                ? <Spinner/>
                : <Text textAlign="center">
                    {t('renewal.confirmation', {count})}
                </Text>
        }

        <HStack align="center" w="100%" gap="2rem" justify="center">
            <Button onClick={() => close()} disabled={isSending}>
                {t('actions.cancel')}
            </Button>
            <Button
                onClick={send}
                disabled={isSending || hasError || count === null || count === 0}
            >
                {isSending ? <Spinner size="sm"/> : t('renewal.send')}
            </Button>
        </HStack>
    </VStack>;
};

export default RenewalMailConfirmation;
